import React from "react";

const RunningHelpInfo = ({ text, title = "Ajuda do campo" }) => (
    <span
        className="running-help-info"
        data-tooltip={`${title}: ${text}`}
        aria-label={`${title}: ${text}`}
        role="img"
    >
        <i className="mdi mdi-information-outline" />
    </span>
);

export default RunningHelpInfo;
